import { useMutation } from '@apollo/client';
import { gql } from 'graphql-tag';

const UPLOAD_RESUME_FILE_MUTATION = gql`
  mutation uploadResume($input: UploadResumeInput!) {
    uploadResume(input: $input) {
      binaryObjectUri
    }
  }
`;

const useUploadResumeFile = () => {
  const [uploadResumeMutation] = useMutation(UPLOAD_RESUME_FILE_MUTATION);

  return async ({ correlatedObjectUri, files }) => {
    const { base64Content, mimeType, keyValues } = files[0];

    try {
      const { data } = await uploadResumeMutation({
        variables: {
          input: {
            userUri: correlatedObjectUri,
            base64Content,
            mimeType,
            keyValues
          }
        }
      });

      const binaryObjectUri = data?.uploadResume?.binaryObjectUri;

      return [null, binaryObjectUri ? [binaryObjectUri] : null];
    } catch (error) {
      return [error, null];
    }
  };
};

export default useUploadResumeFile;
